import { useState } from 'react'

import { useFetch } from 'hooks'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { ChurnStepper } from './components'

import * as service from 'service'

const ChurnsEdit = ({ match }) => {
  const {
    params: { churnId },
  } = match

  const [loading, setLoading] = useState(false)

  const { response, isLoading } = useFetch(
    service.dponet.churns.show,
    { churnId },
    [],
  )

  const churn = isLoading ? {} : response?.data?.churn

  return (
    <Page title="Edição da solicitação de churn">
      {isLoading ? (
        <LoadingFeedback open={isLoading || loading} />
      ) : (
        <Container maxWidth={false}>
          <ContentHeader
            menu="Solicitação de churn"
            title="Edição"
            subtitle="Solicitação de churn"
          />
          <ChurnStepper churn={churn} setLoading={setLoading} />
        </Container>
      )}
    </Page>
  )
}

export default ChurnsEdit
